import React from 'react';
import 'twin.macro';
import { DividerTitle } from '../divider';
import { UploadForm, TipForm } from '../form';
import { MenuHeader, MenuContent } from './';

export const UploadMenu = ({ modalId }) => {
  return (
    <>
      <MenuHeader title='insturen' modalId={modalId} />
      <MenuContent>
        <UploadForm />
        <DividerTitle title='Tip Ons' tw='mt-6 mb-4' />
        <TipForm />
      </MenuContent>
    </>
  );
};
